import base from "@/lib/backendCall/base";

async function createProposal(content, options) {
    return await base.httpReq(
        true,
        "post",
        `/proposal`,
        {content, options},
        null
    )
}

async function getProposalsAndMyVotingRecords(storeAccount, myAccount) {
    return await base.httpReq(
        true,
        "get",
        `/proposal`,
        null,
        {
            storeAccount,
            customerAccount: myAccount
        }
    )
}

async function getProposalContent(proposalId) {
    return await base.httpReq(
        true,
        "get",
        `/proposal/content`,
        null,
        {proposalId}
    )
}

export default {
    createProposal,
    getProposalsAndMyVotingRecords,
    getProposalContent
}